let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7I8FK")).then(() => parcelRequire('gR0Ux'));